import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../../context/notificationContext";
import { useI18n } from "../../../hooks/useTranslations";
import { useDefaultTasksApi } from "../../../http/defaultTasks/api";
import ModalDialog from "../../ui/ModalDialog";

interface DeleteDefaultTaskDialogProps {
  defaultTaskId: string;
  onClose: () => void;
}

const DeleteDefaultTaskDialog: FC<DeleteDefaultTaskDialogProps> = ({ defaultTaskId, onClose }) => {
  const i18n = useI18n();
  const defaultTaskApi = useDefaultTasksApi();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useContext(NotificationDispatch);

  return (
    <ModalDialog
      onClose={onClose}
      isSubmitting={isSubmitting}
      title={i18n.t.defaultTasks.delete}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            defaultTaskApi
              .deleteAdminDefaultTask(defaultTaskId)
              .then(onClose)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.defaultTasks.questions.delete}
    </ModalDialog>
  );
};

export default DeleteDefaultTaskDialog;
